import { render, staticRenderFns } from "./PaseTable.vue?vue&type=template&id=73bde304"
import script from "./PaseTable.vue?vue&type=script&lang=ts"
export * from "./PaseTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports